import {ISpinnerProps, Spinner} from '@mintdata/mint-kit/impl/components/spinner/Spinner';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./PageLoader.less');
const cx = classnames.bind(styles);

export interface PageLoaderProps
{
    className?:string
    spinnerProps?:ISpinnerProps;
    text?:string | JSX.Element;
}

@observer
export class PageLoader extends React.Component<PageLoaderProps, any>
{
    public render()
    {
        const {spinnerProps, text} = this.props;

        return (
            <div className={cx('overlap')}>
                <div className={cx('spinner')}>
                    <Spinner {...spinnerProps} />
                    {text && <p className={cx('text')}>{text}</p>}
                </div>
            </div>
        );
    }
}
